/**
 * Visit lengths are kept in minutes everywhere behind the screen; people read and type them
 * in hours: 90 minutes is "1.5 hrs", 60 is "1 hr", 45 is "0.75 hrs".
 */

/** Hours as a plain number, to two decimal places at most: 90 is "1.5", 100 is "1.67". */
export const hoursOf = (minutes: number) => String(Math.round((minutes / 60) * 100) / 100);

/** A length to read: "1.5 hrs", "1 hr". */
export const hoursLabel = (minutes: number) => {
  const h = hoursOf(minutes);
  return `${h} ${h === '1' ? 'hr' : 'hrs'}`;
};

/**
 * What was typed in an hours field, back to whole minutes: "1.5" is 90, "1,5" too. Anything
 * that is not a number is 0, which the server turns down with its own message.
 */
export const minutesFrom = (hours: string) => {
  const n = Number(hours.trim().replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? Math.round(n * 60) : 0;
};
